import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurst: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBurst"><Path d="M11.25 19H12.75V23H11.25V19ZM8.56055 16.5L4.75 20.3105L3.68945 19.25L7.5 15.4395L8.56055 16.5ZM20.3105 19.25L19.25 20.3105L15.4395 16.5L16.5 15.4395L20.3105 19.25ZM5 11.25V12.75H1V11.25H5ZM23 11.25V12.75H19V11.25H23ZM8.56055 7.5L7.5 8.56055L3.68945 4.75L4.75 3.68945L8.56055 7.5ZM20.3105 4.75L16.5 8.56055L15.4395 7.5L19.25 3.68945L20.3105 4.75ZM11.25 1H12.75V4.99023H11.25V1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBurst;
